import { ICustomer } from '../../../../../data/entities/customer';
import { actions } from '../../../../../data/store';
import { updateByCustomer } from '../../../../../entities/contracts/actions';
import { IContracts } from '../../../../../entities/contracts/types';

import { ActionTypeNames, ActionValues, createActionCreators } from '../../../../../store/actions';
import { ThunkAction } from '../../../../../store/middleware';

const adminCustomerEditViewActions = createActionCreators<
	{ T: 'ADMIN_CUSTOMER_UPDATE_DETAILS_REQUEST' },
	{ T: 'ADMIN_CUSTOMER_UPDATE_DETAILS_RECEIVE' },
	{ T: 'ADMIN_CUSTOMER_UPDATE_DETAILS_FAILURE', P: { error: Error } }
>('ADMIN_CUSTOMER_UPDATE_DETAILS_REQUEST', 'ADMIN_CUSTOMER_UPDATE_DETAILS_RECEIVE', 'ADMIN_CUSTOMER_UPDATE_DETAILS_FAILURE');

export const adminUpdateCustomerdetails = (
	customer: ICustomer,
	contracts: IContracts,
): ThunkAction =>
	async (dispatch, getState, { _deprecatedApi: api }) => {
		dispatch(adminCustomerEditViewActions.ADMIN_CUSTOMER_UPDATE_DETAILS_REQUEST());
		try {
			await Promise.all([
				dispatch(actions.customer.update(customer)),
				dispatch(updateByCustomer(customer.id, contracts)),
			]);
			dispatch(adminCustomerEditViewActions.ADMIN_CUSTOMER_UPDATE_DETAILS_RECEIVE());
		} catch (error) {
			dispatch(adminCustomerEditViewActions.ADMIN_CUSTOMER_UPDATE_DETAILS_FAILURE({ error }));
		}
	};

type UserActions = ActionValues<typeof adminCustomerEditViewActions>;
type UserActionTypes = ActionTypeNames<UserActions>;
export type Actions = UserActions[keyof UserActions];
export const ActionTypes = Object.keys(adminCustomerEditViewActions).reduce((types, t) => {
	types[t] = t;
	return types;
}, {} as UserActionTypes);
